import type { QuantityDiffStatus } from "./utils/computeQuantityDiff";

// Shared by both tabs so a status always reads as the same color.
export const STATUS_DOT_CLASS: Record<QuantityDiffStatus, string> = {
  added: "bg-green-500",
  removed: "bg-red-500",
  changed: "bg-amber-500",
  unchanged: "bg-gray-300",
};
